import React from "react";
import { graphql } from "gatsby";
import { formatLinks } from "../../lib/links";
import { DesktopNav } from "../../components/siteframe/Header/DesktopNav";
import { MobileNav } from "../../components/siteframe/Header/MobileNav";
import { OpenHours } from "../../lib/useOpenHours";
import { getOpenHours } from "../../lib/openHours";

const HeaderNav: React.FC<any> = ({
  data,
  background,
  backgroundColor,
  ...props
}) => {
  const today = new Date().toLocaleDateString("en", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const menuItems = data?.kontentItemDataHeader?.elements.menu_items.value.map(
    (menuItem) => {
      const label = menuItem.elements.label.value.toUpperCase();

      const links = menuItem.elements.links.value.map((link) => {
        if (
          link.internal?.type === "kontent_item_element___link_with_sublinks"
        ) {
          const primaryLink = formatLinks(
            link.elements.primary_link?.modular_content
          )[0];

          return {
            label: primaryLink?.label.toUpperCase(),
            to: primaryLink.href,
            target: primaryLink.target,
            links: link.elements.sublinks,
          };
        }

        if (link.internal?.type === "kontent_item_element___link") {
          const singleLink = formatLinks([link])[0];

          return {
            label: singleLink.label.toUpperCase(),
            to: singleLink.href,
            target: singleLink.target,
          };
        }
      });

      return {
        label,
        links,
      };
    }
  );

  let customHours =
    {} as OpenHours["kontentItemDataHoursOfOperation"]["elements"]["custom_hours"]["compiled"];

  const hoursData = data.kontentItemDataHoursOfOperation.elements;

  hoursData?.custom_hours?.value
    .filter((customHour) => {
      const today = new Date();
      const customDate = new Date(customHour?.elements?.date?.value);

      const customDateAfterToday =
        today.getFullYear() <= customDate.getFullYear() &&
        today.getMonth() <= customDate.getMonth() &&
        today.getDate() <= customDate.getDate();

      return (
        customDateAfterToday ||
        customHour?.elements?.recurring?.value[0]?.codename === "yes"
      );
    })
    .forEach((customHour) => {
      let date = new Date(customHour.elements.date.value);

      let key = `${date.getMonth()}${date.getDate()}`;

      if (customHours && customHours[key]) {
        customHours[key].push({
          open: customHour.elements.open,
          close: customHour.elements.close,
        });
      } else if (customHours) {
        customHours[key] = [
          {
            open: customHour.elements.open,
            close: customHour.elements.close,
          },
        ];
      }
    });

  if (customHours && Object.keys(customHours)) {
    hoursData.custom_hours["compiled"] = customHours;
  }

  const openHours = getOpenHours(hoursData);

  return (
    <>
      <DesktopNav
        openHours={openHours}
        today={today}
        backgroundColor={backgroundColor}
        background={background}
        navigation={menuItems}
      />
      <MobileNav openHours={openHours} today={today} navigation={menuItems} />
    </>
  );
};

export default HeaderNav;

export const HeaderNavQuery = graphql`
  query {
    kontentItemDataHeader(system: { name: { eq: "LindaHall.org Header" } }) {
      id
      system {
        name
      }
      elements {
        menu_items {
          value {
            ... on kontent_item_element___menu_item {
              id
              elements {
                label {
                  value
                }
                links {
                  value {
                    ...kontentRichTextLink
                    ...kontentRichTextLinkWithSublink
                  }
                }
              }
            }
          }
        }
      }
    }
    kontentItemDataHoursOfOperation(system: { name: { eq: "Library Hours" } }) {
      elements {
        open_hours
        combined_days
        custom_hours {
          value {
            system {
              id
            }
            ... on kontent_item_data___custom_hours {
              id
              elements {
                date {
                  value
                }
                open {
                  value
                }
                close {
                  value
                }
                recurring {
                  value {
                    codename
                  }
                }
              }
            }
          }
        }
      }
      system {
        name
      }
    }
  }
`;
